export default __webpack_public_path__ + "static/media/delhi.dab8f072.png";